export enum Workflow {
    AUDIT = 'audit',
    AUDIT_WITH_ADVANCE_NOTIFICATION = 'auditWithAdvanceNotification',
    EVALUATION = 'evaluation',
}

export const WORKFLOW_NAMES: Record<Workflow, string> = {
    [Workflow.AUDIT]: $localize`:@@workflow.audit:Gesamter Betrieb`,
    [Workflow.AUDIT_WITH_ADVANCE_NOTIFICATION]: $localize`:@@workflow.auditWithAdvanceNotification:Traubenlieferant`,
    [Workflow.EVALUATION]: $localize`:@@workflow.evaluation:Testbewertung`,
};
